import { render } from "./ScheduleDayView.vue?vue&type=template&id=0b02d682"
import script from "./ScheduleDayView.vue?vue&type=script&lang=ts"
export * from "./ScheduleDayView.vue?vue&type=script&lang=ts"
script.render = render

export default script